module.exports = __webpack_public_path__ + "static/media/disclosure.a0303b6a.svg";